// extracted by mini-css-extract-plugin
export default {"asset-transfer-loading-dim-overlay":"AssetDetails_asset-transfer-loading-dim-overlay__9CIjP"};